const postalCodeRegex =
	/(^[\d]{5}$)|(^[A-CEGHJ-NPR-TVX]\d[A-CEGHJ-NP-TV-XZ]\s\d[A-CEGHJ-NPR-TV-XZ]\d$)/i;

/**
 * @param {string | null | undefined} value
 * @returns {string[]}
 */
export function parsePostalCodeList(value) {
	if (typeof value !== 'string') {
		return [];
	}

	return Array.from(
		new Set(
			value
				.split(/[\n,]+/)
				.map((postalCode) => postalCode.trim())
				.filter(Boolean)
		)
	);
}

/**
 * @param {string | null | undefined} value
 * @returns {boolean}
 */
export function isValidPostalCode(value) {
	return typeof value === 'string' && postalCodeRegex.test(value.trim());
}

/**
 * @param {string | null | undefined} value
 * @returns {string}
 */
export function normalizePostalCodeList(value) {
	return parsePostalCodeList(value).join(', ');
}
